import React from 'react';
import { DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AppDialogTitle = ({ children, onClose, ...other }) => {
    return (
        <DialogTitle
            sx={{
                m: 0,
                p: 2,
                fontSize: 24,
                fontWeight: 600,
                bgcolor: 'action.hover',
                borderBottom: '1px solid',
                borderColor: 'divider',
                position: 'relative',
                mb: 1.5
            }}
            {...other}
        >
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 12,
                        top: 12,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

export default AppDialogTitle;